var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "demo" } },
    [
      _c("link", {
        attrs: {
          href:
            "https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css",
          rel: "stylesheet",
          integrity:
            "sha384-wvfXpqpZZVQGK6TAh5PVlGOfQNHSoD2xbE+QkPxCAFlNEevoEH3Sl0sibVcOQVnN",
          crossorigin: "anonymous"
        }
      }),
      _vm._v(" "),
      _c(
        "balloon",
        {
          attrs: {
            title: "One Cute Cat",
            position: "bottom-right",
            zooming: true
          },
          on: { maximize: _vm.playVideo, minimize: _vm.pauseVideo }
        },
        [
          _c("template", { attrs: { slot: "header" }, slot: "header" }, [
            _vm._v("Custom Header")
          ]),
          _vm._v(" "),
          _c("youtube", {
            ref: "player",
            staticClass: "video",
            attrs: { "video-id": _vm.videoId }
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-430be292", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-430be292","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./demo/DemoSingle.vue
// module id = TB7G
// module chunks = 0